<script>
import MonitoringReport from '@/views/pages/monitoring-report/MonitoringReport.vue'

export default {
  name: 'MonitoringReportInno',
  components: { MonitoringReport },
}
</script>

<template>
  <monitoring-report type="monitoringReportInnovationList" />
</template>

<style scoped>

</style>
